import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative h-[520px] md:h-[640px] w-full overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Epic%20Chinese%20manhua%20style%20illustration%20with%20dramatic%20ink%20wash%20painting%20aesthetic%2C%20silhouettes%20of%20martial%20arts%20warriors%20in%20flowing%20robes%2C%20misty%20mountains%2C%20ancient%20Chinese%20architecture%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20atmospheric%20and%20cinematic%20composition%2C%20stylized%20art%20with%20bold%20brushwork%20textures&width=1600&height=720&seq=hero-manga-bg&orientation=landscape"
        alt="九妖漫画网 - 免费在线看漫画全集"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 hero-bg-overlay"></div>

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-4 w-full">
        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight">
          九妖漫画网
        </h1>
        <p className="text-base md:text-lg text-white/80 max-w-2xl mb-8 leading-relaxed">
          免费在线看漫画全集，高清无删减资源，让您一站式阅读所有漫画
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <Link
            to="/category/rexue"
            className="px-8 py-3 bg-primary-500 text-white rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap"
          >
            开始阅读
            <div className="w-4 h-4 inline-flex items-center justify-center ml-1">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/15 backdrop-blur-sm text-white border border-white/30 rounded-full font-medium text-sm hover:bg-white/25 transition-all duration-300 whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-4 md:gap-8">
          {[
            { value: '30,000+', label: '漫画作品' },
            { value: '500万+', label: '累计用户' },
            { value: '300+', label: '每日更新' },
            { value: '98%', label: '好评率' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-xl md:text-2xl font-bold text-white">{stat.value}</div>
              <div className="text-xs md:text-sm text-white/60 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}